"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcBreadcrumbV2FloatMenu = void 0;
var bc_breadcrumb_v2_constants_1 = require("./bc-breadcrumb-v2-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var BcBreadcrumbV2FloatMenu = (function () {
    function BcBreadcrumbV2FloatMenu(breadCrumbItemsList, visibleItems) {
        this.breadCrumbItemsList = breadCrumbItemsList;
        this.visibleItems = visibleItems;
    }
    BcBreadcrumbV2FloatMenu.prototype.generateFloatMenu = function () {
        return this._setFloatMenu();
    };
    BcBreadcrumbV2FloatMenu.prototype._setFloatMenu = function () {
        this._updateClassFloatMenuItems();
        return this._createLiElement();
    };
    BcBreadcrumbV2FloatMenu.prototype._updateClassFloatMenuItems = function () {
        this.breadCrumbItemsList.forEach(function (item) {
            item.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_FLOAT_MENU_OPTIONS);
        });
    };
    BcBreadcrumbV2FloatMenu.prototype._createUlElementItems = function () {
        var ulElement = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
        this.breadCrumbItemsList.forEach(function (item) {
            ulElement.appendChild(item);
        });
        return ulElement;
    };
    BcBreadcrumbV2FloatMenu.prototype._createContainerFloatMenu = function () {
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_FLOAT_MENU_CONTENT);
        sectionElement.appendChild(this._createUlElementItems());
        return sectionElement;
    };
    BcBreadcrumbV2FloatMenu.prototype._createArrowFloatMenu = function () {
        var arrowElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        arrowElement.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_FLOAT_MENU_ARROW);
        return arrowElement;
    };
    BcBreadcrumbV2FloatMenu.prototype._createFloatMenu = function () {
        var floatMenu = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        floatMenu.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_FLOAT_MENU, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_FLOAT_MENU_ARROW_CENTER);
        floatMenu.appendChild(this._createArrowFloatMenu());
        floatMenu.appendChild(this._createContainerFloatMenu());
        return floatMenu;
    };
    BcBreadcrumbV2FloatMenu.prototype._createIcon = function () {
        var icon = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        icon.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_ICON);
        icon.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, common_constants_1.BcCommonConstants.TRUE.toString());
        icon.innerText = bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_ICON_MENU_DOTS;
        return icon;
    };
    BcBreadcrumbV2FloatMenu.prototype._createIconButton = function () {
        var iconButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        iconButton.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_ICON_BUTTON, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_ICON_BUTTON_GHOST, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_ICON_BUTTON_SMALL, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_FLOAT_MENU_TOGGLE);
        iconButton.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_FLOAT_MENU_BUTTON_READER);
        iconButton.appendChild(this._createIcon());
        return iconButton;
    };
    BcBreadcrumbV2FloatMenu.prototype._createLiElement = function () {
        var liElement = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
        liElement.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM_MENU_CLASS);
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElement.appendChild(this._createIconButton());
        divElement.appendChild(this._createFloatMenu());
        liElement.appendChild(divElement);
        return liElement;
    };
    return BcBreadcrumbV2FloatMenu;
}());
exports.BcBreadcrumbV2FloatMenu = BcBreadcrumbV2FloatMenu;
